import React from "react";
import useListProduits from "../hooks/useListProduits";
import useListVentes from "../hooks/useListVentes";
import useListCommandes from "../hooks/useListCommandes";

const DataContext = React.createContext();

export const useData = () => React.useContext(DataContext);

export const DataProvider = ({ children }) => {
	const produits = useListProduits();

	const { prochaineVente, venteEnCours, ancienneVente, fetchDataVentes } =
		useListVentes();
	const {
		ancienneCommandes,
		commandeEnCours,
		prochaineCommandes,
		fetchDataCommandes,
	} = useListCommandes();

	return (
		<DataContext.Provider
			value={{
				produits,
				prochaineVente,
				venteEnCours,
				ancienneVente,
				ancienneCommandes,
				commandeEnCours,
				prochaineCommandes,

				fetchDataCommandes,
				fetchDataVentes,
			}}
		>
			{children}
		</DataContext.Provider>
	);
};
